export default __webpack_public_path__ + "static/media/Smile.7aab0382.svg";